import {useEffect, useState} from 'react'
import View from './View'
import Loading from "../../../../Loading";
import {useGetCustomBids, useGetRecommended} from "../../../../../core/hooks";
import {LAMP_FILTER, LAMP_FILTER_MIN, PRODUCT_TYPES} from "../../../../../constants/types";
import {SU} from "../../../../../constants/user/userEnum";
import {setLedsForAll, updateProductType} from "../../../../../constants/utils";

const Lamp = ({
                  description,
                  lamp,
                  setCustomPricing,
                  customPricing,
                  setLamp,
                  fromAll,
                  project,
                  type,
                  onClose,
                  reportId,
                  setRecent,
                  createKey,
                  setCreateKey,
                  area,
                  luminaire,
                  setArea,
                  luminaireId,
                  setType
              }) => {
    const [fetchedDataLamp, setFetchedDataLamp] = useState([])
    const [lampDisabled, setLampDisabled] = useState(false)
    const [selectAll, setSelectAll] = useState(false);
    const [lampAirtable, setLampAirtable] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [buyAmerican, setBuyAmerican] = useState(false);
    const filters = {
        wattageMin: lamp?.lampRecomendedWattageMinimum ?? '',
        wattageMax: lamp?.lampRecomendedWattageMaximum ?? '',
        colorMin: lamp?.lampRecomendedColorMinimum ?? '',
        colorMax: lamp?.lampRecomendedColorMaximum ?? '',
        lumensMin: lamp?.lampRecomendedLumensMinimum ?? '',
        lumensMax: lamp?.lampRecomendedLumensMaximum ?? '',
        priceMin: lamp?.lampRecomendedPriceMinimum ?? '',
        priceMax: lamp?.lampRecomendedPriceMaximum ?? '',
        dimmability: lamp?.lampRecomendedDimmability ?? '',
    }
    const [customBids, setCustomBids] = useState([]);
    const [certifications, setCertifications] = useState([])
    const [expandedSearch, setExpandedSearch] = useState([])

    const {data, isLoading, isFetching,refetch} = useGetRecommended(
        {
            condition: {
                table: PRODUCT_TYPES["2"],
                filter: LAMP_FILTER(luminaire),
                filterMin: LAMP_FILTER_MIN(luminaire),
                projectId: project?.id
            }
        },
        expandedSearch.length > 0 ? LAMP_FILTER(luminaire, expandedSearch) : undefined
    )
    const {data: dataCustomBids, isLoading: isLoadingBids,isFetching:isFetchingBids, refetch: refetchBids} = useGetCustomBids(
        {
            condition: {
                type: 'report',
                projectId: project?.id,
                productType: 'lamp',
                reportId: reportId,
                userType: SU,
            }
        }
    )

    useEffect(() => {
        if (type === 'lamp') {
            refetch()
        }
    }, [type])

    const validate = ({ fields }) => {
        let bool = true;
        const safeReplace = (value) =>
            typeof value === "string"
                ? value.replace(/[^\d.]/g, "")
                : value != null
                    ? value.toString().replace(/[^\d.]/g, "")
                    : "0";

        if (buyAmerican && bool) {
            !!fields["Buy America"]
                ? (bool = fields["Buy America"] === "Yes")
                : (bool = false);
        }

        const hasWattageMin = filters.wattageMin != null && filters.wattageMin !== '';
        const hasWattageMax = filters.wattageMax != null && filters.wattageMax !== '';
        if ((hasWattageMin || hasWattageMax) && bool) {
            const wattage = parseFloat(fields["Wattage"]);
            bool = Number.isFinite(wattage)
                && (!hasWattageMin || wattage >= Number(filters.wattageMin))
                && (!hasWattageMax || wattage <= Number(filters.wattageMax));
        }

        if (certifications.length > 0 && bool) {
            const productCertifications = Array.isArray(fields["Certifications"])
                ? fields["Certifications"] : [fields["Certifications"]];
            bool = productCertifications.some(certification => certifications.includes(certification));
        }

        if (!!filters.colorMin && !!filters.colorMax && bool) {
            const color = fields["CCT (K˚)"] ?? fields["Color"];
            const temperatures = (String(color ?? '').match(/\d+(?:\.\d+)?/g) ?? []).map(Number);
            bool = temperatures.some(temperature =>
                Number(filters.colorMin) <= temperature && Number(filters.colorMax) >= temperature
            );
        }

        const hasPriceMin = filters.priceMin != null && filters.priceMin !== '';
        const hasPriceMax = filters.priceMax != null && filters.priceMax !== '';
        if ((hasPriceMin || hasPriceMax) && bool) {
            const hasCustomPrice = !!fields["SU PPU ($) Custom"];
            const rawPrice = hasCustomPrice ? fields["SU PPU ($) Custom FE"] : fields["FE PPU ($)"];
            const parsedPrice = typeof rawPrice === 'number'
                ? rawPrice
                : parseFloat(String(rawPrice ?? '').replace(/[^0-9.-]/g, ''));
            const price = hasCustomPrice ? parsedPrice : Number(parsedPrice.toFixed(2));
            bool = Number.isFinite(price)
                && (!hasPriceMin || Number(filters.priceMin) <= price)
                && (!hasPriceMax || Number(filters.priceMax) >= price);
        }

        if (!!filters.lumensMin && !!filters.lumensMax && bool && fields["Lumens"]) {
            !!fields["Lumens"]
                ? (bool =
                    parseInt(filters.lumensMin) < parseInt(fields["Lumens"]) &&
                    parseInt(filters.lumensMax) > parseInt(fields["Lumens"]))
                : (bool = false);
        }
        if (!!filters.dimmability && bool) {
            !!fields["Dimmable"]
                ? (bool = fields["Dimmable"].includes(filters.dimmability))
                : (bool = false);
        }
        if (customPricing.lamp && bool) {
            !fields.hasOwnProperty("Price Per Unit ($)") ||
            !fields["Price Per Unit ($)"] ||
            Number(safeReplace(fields["Price Per Unit ($)"])) == 0
                ? (bool = true)
                : (bool = false);
        }

        if (!customPricing.lamp && bool) {
            if (
                !fields.hasOwnProperty("Price Per Unit ($)") &&
                !fields.hasOwnProperty("SU PPU ($) Custom")
            ) {
                bool = false;
            } else if (
                fields["Price Per Unit ($)"] &&
                !fields["SU PPU ($) Custom"] &&
                Number(fields["Price Per Unit ($)"]?.toString()?.replace(/[^\d.]/g, "")) ===
                0
            ) {
                bool = false;
            } else {
                bool = true;
            }
        }

        return bool;
    };

    const create = () => {
        let obj = setLedsForAll(area, luminaire);
        const updatedArea = updateProductType(area, obj, 'lamp', lamp, fromAll, luminaireId);

        setArea(updatedArea);
    }


    useEffect(() => {
        if (createKey === true) {
            create()
            setCreateKey(false)
            onClose()
        }
    },[createKey])

    useEffect(() => {
        if (!data) return
        setFetchedDataLamp(data?.data?.data)
        setLamp({
            ...lamp,
            recomendedLampQty: luminaire.recomendedLampQty ? luminaire.recomendedLampQty  : (luminaire.lampPerFixture ? luminaire.lampPerFixture : '')
        })
        if (luminaire?.fixtureRecomendedAirtableArray?.length > 0) {
            let recom = luminaire?.fixtureRecomendedAirtableArray[0]['fields']
            setLampDisabled(!!recom['Wattage'])
        } else {
            setLampDisabled(false)
        }
        setSelectedItems(lamp?.lampRecomendedCustomPriceIdes?.length > 0 ? lamp.lampRecomendedCustomPriceIdes : luminaire?.lampRecomendedCustomPriceIdes?.length > 0 ? luminaire.lampRecomendedCustomPriceIdes : [])
        setLampAirtable(lamp?.lampRecomendedAirtableArray?.length > 0 ? lamp.lampRecomendedAirtableArray : luminaire?.lampRecomendedAirtableArray?.length > 0 ? luminaire.lampRecomendedAirtableArray : [])
        if (dataCustomBids){
            setCustomBids(dataCustomBids.data.data)
        }
        data.data.data.forEach(item1 => {
            item1.fields['Bid Status'] = 'review'
            if (dataCustomBids){
                dataCustomBids.data.data.forEach(item2 => {
                    if (item1.id === item2.fields['Product ID']) {
                        if (item2.fields['SU PPU ($)']){
                            item1.fields['SU PPU ($) Custom'] = item2.fields['SU PPU ($)'];
                            item1.fields['SU PPU ($) Custom FE'] = item2.fields['FE PPU ($)'];
                            item1.fields['Bid Status'] = 'accepted'
                        } else {
                            item1.fields['Bid Status'] = 'pending'
                        }
                    }
                });
            }
        });
    }, [data, dataCustomBids])

    const handleSelect = (item) => {
        setSelectedItems(prevSelectedItems => {
            if (prevSelectedItems.includes(item)) {
                return prevSelectedItems.filter(i => i !== item);
            } else {
                return [...prevSelectedItems, item];
            }
        });
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([]);
        } else {
            setSelectedItems(fetchedDataLamp?.filter((item) => validate(item) === true).map(item => item.id));
        }
        setSelectAll(!selectAll);
    };

    useEffect(() => {
        if (selectedItems.length > 0) {
            if (customPricing.lamp) {
                setLamp({
                    ...lamp,
                    lampRecomendedCustomPriceIdes: selectedItems,
                    lampRecomendedAirtable: lampAirtable?.length > 0 && JSON.stringify(lampAirtable[0].fields),
                })
            } else {
                setLamp({
                    ...lamp,
                    lampRecomendedCustomPriceIdes: [],
                })
            }
        }  else {
            setLamp({
                ...lamp,
                lampRecomendedCustomPriceIdes: [],
            })
        }
    }, [selectedItems])

    useEffect(() => {
        if (lampAirtable.length > 0){
            setLamp({
                ...lamp,
                lampRecomendedAirtable: JSON.stringify(lampAirtable[0].fields),
                lampRecomendedAirtableArray: lampAirtable,
                lampRecomendedDescription: lampAirtable[0].fields['FE Product Description'],
                lampRecomendedPrice: lampAirtable[0].fields['Price Per Unit ($)'],
                lampRecomendedWattage: lampAirtable[0].fields['Wattage']
            })
        } else {
            setLamp({
                ...lamp,
                lampRecomendedAirtable: [],
                lampRecomendedAirtableArray: [],
                lampRecomendedDescription: '',
                lampRecomendedPrice: '',
                lampRecomendedWattage: ''
            })
        }
    },[lampAirtable])

    if (isLoading) return <Loading height='100%'/>

    return (
        <View
            isFetchingBids={isFetchingBids}
            isFetching={isFetching}
            setBuyAmerican={setBuyAmerican}
            buyAmerican={buyAmerican}
            setIsOpen={setIsOpen}
            certifications={certifications}
            setCertifications={setCertifications}
            expandedSearch={expandedSearch}
            setExpandedSearch={setExpandedSearch}
            isOpen={isOpen}
            projectId={project?.id}
            refetch={refetch}
            selectedItems={selectedItems}
            customPricing={customPricing}
            setLampAirtable={setLampAirtable}
            handleSelectAll={handleSelectAll}
            selectAll={selectAll}
            handleSelect={handleSelect}
            fromAll={fromAll}
            lampAirtable={lampAirtable}
            setCustomPricing={setCustomPricing}
            lampDisabled={lampDisabled}
            validate={validate}
            luminaire={luminaire}
            setSelectedItems={setSelectedItems}
            setType={setType}
            fetchedDataLamp={fetchedDataLamp}
            lamp={lamp}
            description={description}
            setLamp={setLamp}
            create={create}/>
    )
}

export default Lamp
